/**
 * @param viewCount 閲覧数（整数）
 * @returns 表示用の文字列
 * @see https://zozo.rickcloud.jp/wiki/pages/viewpage.action?pageId=663857279
 */
export const viewCountToString = (viewCount: number): string => {
  if (viewCount <= 0) return '0'
  if (viewCount >= 99_999_000) return '9,999.9万'
  if (viewCount < 10_000) return viewCount.toLocaleString()
  const over10K = Math.floor(viewCount / 10_000)
  const thousand = Math.floor((viewCount % 10_000) / 1_000)
  if (thousand === 0) return `${over10K.toLocaleString()}万`
  return `${over10K.toLocaleString()}.${thousand}万`
}
